import { SetupContext } from '@vue/composition-api'
import { useValid } from '@/lib/billing/utils'
import {
  DetailsState,
  DetailsItemType,
  SummaryType,
  ServiceType,
} from '@/@types/billing/details'

import { difference } from 'underscore'

export const useParents = (state: any, context: SetupContext) => {
  const { handleDiffCheckDetailsOfDetails } = useValid(context)

  const existData = (arrayLength: number) => {
    if (arrayLength === 0) {
      alert(`請求データが1つもありません。`)
      return
    }
  }

  const handleResetData = () => {
    // vuexにストアするdataをmasterに切り替える
    context.root.$store.commit(
      'parentsDetailsSelect/valueSet',
      JSON.parse(JSON.stringify(state.defaultSelectSet))
    )
  }

  const handleNullToEmptyString = (data: any) => {
    Object.keys(data).forEach(key => {
      if (
        (data[key] && typeof data[key] === 'object') ||
        Array.isArray(data[key])
      ) {
        return handleNullToEmptyString(data[key])
      } else {
        if (data[key] === null || data[key] === undefined) {
          data[key] = ''
          return true
        } else {
          return true
        }
      }
    })

    return data
  }

  const handleFindErr = (data: any) => {
    const res = Object.keys(data).some(key => {
      if (
        (data[key] && typeof data[key] === 'object') ||
        Array.isArray(data[key])
      ) {
        return handleFindErr(data[key])
      } else {
        if (data[key]) {
          return true
        }
      }
    })

    return res
  }

  const handleCheckValid = (data: any) => {
    console.log(data)

    const emptyCheckArray = ['atCost', 'invoiceNo']

    const errAllObj: any = {}

    emptyCheckArray.forEach(key => {
      if (key === 'atCost') {
        // 空チェック保険外項目
        errAllObj[key] = []

        for (let index = 0; index < data[key].length; index++) {
          if (
            Object.keys(data[key][index]).some(
              (subkey: string) =>
                data[key][index][subkey] || data[key][index][subkey] === 0
            )
          ) {
            const errObj: any = {}

            Object.keys(data[key][index]).forEach((subkey: string) => {
              if (data[key][index][subkey] === '' && subkey !== 'tax') {
                errObj[subkey] = true
              }
            })

            if (Object.keys(errObj).length !== 0) {
              errAllObj[key][index] = errObj
            }
          }
        }
        return
      } else if (key === 'invoiceNo') {
        if (data.details.length !== 0 && data[key] === '') {
          errAllObj[key] = true
        }
      }
    })

    console.log(errAllObj)

    context.root.$store.commit('parentsValid/valueErrSet', errAllObj)

    return handleFindErr(errAllObj)
  }

  const handleDiffCheckParentsDetails = (master: any, transaction: any) => {
    const errViewArray: string[] = []

    const parentsDetailsCheckKeyArray: {
      checkKey: string
      msg: string
    }[] = [
      {
        checkKey: 'parents_name',
        msg: '保護者名',
      },
      {
        checkKey: 'child_name',
        msg: 'ご利用者名',
      },
      {
        checkKey: 'basicSurvey',
        msg: 'ご利用者の住所',
      },
      {
        checkKey: 'office_name',
        msg: '事業所名',
      },
      {
        checkKey: 'office_address',
        msg: '事業所の住所',
      },
      {
        checkKey: 'office_tel',
        msg: '事業所の電話番号',
      },
      {
        checkKey: 'notes_for_parent_request',
        msg: '保護者請求書の備考欄',
      },
    ]

    parentsDetailsCheckKeyArray.forEach(
      (checkObj: { checkKey: string; msg: string }) => {
        switch (checkObj.checkKey) {
          case 'basicSurvey':
            {
              if (
                !(
                  master.child[checkObj.checkKey] &&
                  transaction.child[checkObj.checkKey]
                )
              ) {
                errViewArray.push(`・${checkObj.msg}が異なります。`)
                break
              }

              const masterBasicSurvey = JSON.parse(
                master.child[checkObj.checkKey]
              )

              const transactionBasicSurvey = JSON.parse(
                transaction.child[checkObj.checkKey]
              )

              if (
                !(
                  masterBasicSurvey.basicSurvey1 &&
                  transactionBasicSurvey.basicSurvey1
                )
              ) {
                errViewArray.push(`・${checkObj.msg}が異なります。`)
                break
              }

              if (
                `${masterBasicSurvey.basicSurvey1.zip}${masterBasicSurvey.basicSurvey1.prefecture}${masterBasicSurvey.basicSurvey1.city}${masterBasicSurvey.basicSurvey1.block}${masterBasicSurvey.basicSurvey1.building}` !==
                `${transactionBasicSurvey.basicSurvey1.zip}${transactionBasicSurvey.basicSurvey1.prefecture}${transactionBasicSurvey.basicSurvey1.city}${transactionBasicSurvey.basicSurvey1.block}${transactionBasicSurvey.basicSurvey1.building}`
              ) {
                errViewArray.push(`・${checkObj.msg}が異なります。`)
              }
            }
            break

          case 'parents_name':
            if (
              `${master.child.parents_first_name_1}${master.child.parents_last_name_1}` !==
              `${transaction.child.parents_first_name_1}${transaction.child.parents_last_name_1}`
            ) {
              errViewArray.push(`・${checkObj.msg}が異なります。`)
            }
            break

          case 'child_name':
            if (
              `${master.child.first_name}${master.child.last_name}` !==
              `${transaction.child.first_name}${transaction.child.last_name}`
            ) {
              errViewArray.push(`・${checkObj.msg}が異なります。`)
            }
            break

          case 'office_address':
            if (
              `${master.office.zip}${master.office.prefecture}${master.office.city}${master.office.block}${master.office.building}` !==
              `${transaction.office.zip}${transaction.office.prefecture}${transaction.office.city}${transaction.office.block}${transaction.office.building}`
            ) {
              errViewArray.push(`・${checkObj.msg}が異なります。`)
            }
            break

          case 'office_tel':
            if (
              master.office.phone_number !== transaction.office.phone_number
            ) {
              errViewArray.push(`・${checkObj.msg}が異なります。`)
            }
            break

          case 'office_name':
            if (
              master.office[checkObj.checkKey] !==
              transaction.office[checkObj.checkKey]
            ) {
              errViewArray.push(`・${checkObj.msg}が異なります。`)
            }
            break

          case 'notes_for_parent_request':
            if (
              master.office[checkObj.checkKey] !==
              transaction.office[checkObj.checkKey]
            ) {
              errViewArray.push(`・${checkObj.msg}が異なります。`)
            }
            break

          default:
            if (master[checkObj.checkKey] !== transaction[checkObj.checkKey]) {
              errViewArray.push(`・${checkObj.msg}が異なります。`)
            }
            break
        }
      }
    )

    const parentsDetailsInInsuranceCheckKeyArray = [
      {
        checkKey: 'batDecisionUbCost',
        msg: '金額（円）',
      },
      // 通所 START
      {
        checkKey: 'batUnits',
        msg: '障害児通所給付費の単位数単価',
      },
      {
        checkKey: 'batTotalCost',
        msg: '障害児通所費用総額（保険内）の内訳（円）',
      },

      {
        checkKey: 'details',
        msg: '',
      },
      // 通所 END
      // 保訪 START
      {
        checkKey: 'visitBatUnits',
        msg: '障害児保訪給付費の単位数単価',
      },
      {
        checkKey: 'visitBatTotalCost',
        msg: '障害児保訪費用総額（保険内）の内訳（円）',
      },
      {
        checkKey: 'visitDetails',
        msg: '',
      },
      // 保訪 END
    ]

    const errViewArrayOfInInsurance: string[] = []

    parentsDetailsInInsuranceCheckKeyArray.forEach(
      (checkObj: { checkKey: string; msg: string }) => {
        switch (checkObj.checkKey) {
          case 'details':
            handleDiffCheckDetailsOfDetails(
              master.details,
              transaction.details,
              errViewArrayOfInInsurance,
              true
            )

            break

          case 'visitDetails':
            handleDiffCheckDetailsOfDetails(
              master.visitDetails,
              transaction.visitDetails,
              errViewArrayOfInInsurance,
              true
            )

            break

          default:
            if (
              transaction[checkObj.checkKey] !== undefined &&
              Number(master[checkObj.checkKey]) !==
                Number(transaction[checkObj.checkKey])
            ) {
              errViewArrayOfInInsurance.push(`・${checkObj.msg}が異なります。`)
            }
            break
        }
      }
    )

    if (errViewArrayOfInInsurance.length !== 0) {
      errViewArray.push('保険内サービスの')
      errViewArray.push(...errViewArrayOfInInsurance)
    }

    const errViewArrayOfNotCoveredInsurance: string[] = []

    const parentsDetailsNotCoveredInsuranceCheckKeyArray = [
      {
        checkKey: 'atCost',
        msg: '',
      },
    ]

    parentsDetailsNotCoveredInsuranceCheckKeyArray.forEach(
      (checkObj: { checkKey: string; msg: string }) => {
        switch (checkObj.checkKey) {
          case 'atCost':
            {
              master.atCost.forEach((masterAtCost: any) => {
                const targetAtCost = transaction.atCost.find(
                  (atCost: any) =>
                    masterAtCost.item === atCost.item &&
                    (String(masterAtCost.beCount) !== String(atCost.beCount) ||
                      String(masterAtCost.units) !== String(atCost.units) ||
                      String(masterAtCost.tax) !== String(atCost.tax)
                    )
                )

                if (targetAtCost) {
                  errViewArrayOfNotCoveredInsurance.push(
                    `・${targetAtCost.item}の数量または単価または消費税率が異なります。`
                  )
                }
              })

              const masterAtCostItemArray = master.atCost.map(
                (atCost: any) => atCost.item
              )

              const transactionAtCostItemArray = transaction.atCost.map(
                (atCost: any) => atCost.item
              )

              const atCostItemDiffArray1 = difference(
                masterAtCostItemArray,
                transactionAtCostItemArray
              )

              const atCostItemDiffArray2 = difference(
                transactionAtCostItemArray,
                masterAtCostItemArray
              )

              const atCostItemDiffArray = Array.from(
                new Set(atCostItemDiffArray1.concat(atCostItemDiffArray2))
              )

              if (atCostItemDiffArray.length !== 0) {
                errViewArrayOfNotCoveredInsurance.push(
                  `・${atCostItemDiffArray.join()}が異なります。`
                )
              }
            }

            break

          default:
            if (master[checkObj.checkKey] !== transaction[checkObj.checkKey]) {
              errViewArrayOfNotCoveredInsurance.push(
                `・${checkObj.msg}が異なります。`
              )
            }
            break
        }
      }
    )

    if (errViewArrayOfNotCoveredInsurance.length !== 0) {
      errViewArray.push('保険外サービスの')
      errViewArray.push(...errViewArrayOfNotCoveredInsurance)
    }

    return errViewArray
  }

  return {
    existData,
    handleResetData,
    handleNullToEmptyString,
    handleFindErr,
    handleCheckValid,
    handleDiffCheckParentsDetails,
  }
}

export const useUtilsByParentsProxyDitails = (state: any) => {
  const existData = (arrayLength: number) => {
    if (arrayLength === 0) {
      alert(`請求データが1つもありません。`)
      return
    }
  }

  const handlePrint = () => {
    const prevHtmlTitle = document.title

    const titleArray = [
      '障害児通所給付費 代理受領額通知書',
      // 事業所名
      state.officeName,
      // 児童名
      `${state.cldLastName} ${state.cldFirstName} さん`,
    ]
    const titleString = titleArray.join(' | ')
    document.title = titleString

    window.print()

    document.title = prevHtmlTitle
  }

  return {
    existData,
    handlePrint,
  }
}

export const handleGetServiceItemByServiceCodeType = (
  service: ServiceType[],
  serviceCodeType = ''
) => {
  let targetServiceItem = null

  if (Array.isArray(service)) {
    if (!serviceCodeType) {
      targetServiceItem = service.find(
        (summaryItem: ServiceType) =>
          summaryItem.serviceCodeType === '61' ||
          summaryItem.serviceCodeType === '63'
      )
    } else {
      targetServiceItem = service.find(
        (summaryItem: ServiceType) =>
          summaryItem.serviceCodeType === serviceCodeType
      )
    }
  }

  return targetServiceItem
}

export const handleGetSummaryItemByBatServiceCodeType = (
  summary: SummaryType[],
  batServiceCodeType = ''
) => {
  let targetSummaryItem = null

  if (Array.isArray(summary)) {
    if (!batServiceCodeType) {
      targetSummaryItem = summary.find(
        (summaryItem: SummaryType) =>
          summaryItem.batServiceCodeType === '61' ||
          summaryItem.batServiceCodeType === '63'
      )
    } else {
      targetSummaryItem = summary.find(
        (summaryItem: SummaryType) =>
          summaryItem.batServiceCodeType === batServiceCodeType
      )
    }
  }

  return targetSummaryItem
}

const setPriceKeyArray = [
  // 'billingAmount',
  'batTotalCost',
  'batBillingAmount',
  'details',
  'visitDetails',
  'batUnits',
  'batDecisionUbCost',
  'batBillingGrantMunicipal',
  'visitBatUnits',
  'visitBatTotalCost',
  'visitBatBillingAmount',
  'visitBatBillingGrantMunicipal',
]

export const handleSetEmptyInvoicePrice = (setSelectInvoice: {
  [key: string]: string | number | { [key: string]: string | number }[]
}) => {
  setPriceKeyArray.forEach((setKey: string) => {
    switch (setKey) {
      case 'details':
      case 'visitDetails':
        setSelectInvoice[setKey] = []

        break

      case 'batDecisionUbCost':
      case 'batBillingAmount':
      case 'batTotalCost':
      case 'batUnits':
      case 'batBillingGrantMunicipal':
      case 'visitBatUnits':
      case 'visitBatTotalCost':
      case 'visitBatBillingAmount':
      case 'visitBatBillingGrantMunicipal':
        setSelectInvoice[setKey] = 0
        break
    }
  })

  setSelectInvoice.billingAmount = 0
}

export const handleSetInvoicePrice = (
  setDetails: DetailsState,
  setSelectInvoice: {
    [key: string]: string | number | { [key: string]: string | number }[]
  }
) => {
  setPriceKeyArray.forEach((setKey: string) => {
    switch (setKey) {
      // 通所 START
      case 'details':
        //通所の明細をフィルタリング
        setSelectInvoice[setKey] = setDetails.details.filter(
          (detailsItem: DetailsItemType) =>
            detailsItem.beServiceCode.slice(0, 2) === '61' ||
            detailsItem.beServiceCode.slice(0, 2) === '63'
        )

        break

      case 'batUnits':
        {
          const targetSummaryItem = handleGetSummaryItemByBatServiceCodeType(
            setDetails.summary
          )

          setSelectInvoice[setKey] = targetSummaryItem
            ? targetSummaryItem.batUnits
            : 0
        }
        break

      case 'batTotalCost':
        {
          const targetSummaryItem = handleGetSummaryItemByBatServiceCodeType(
            setDetails.summary
          )

          setSelectInvoice[setKey] = targetSummaryItem
            ? targetSummaryItem.batTotalCost
            : 0
        }
        break

      case 'batBillingAmount':
        {
          const targetSummaryItem = handleGetSummaryItemByBatServiceCodeType(
            setDetails.summary
          )

          setSelectInvoice[setKey] = targetSummaryItem
            ? targetSummaryItem.batBillingAmount
            : 0
        }
        break

      case 'batBillingGrantMunicipal':
        {
          const targetSummaryItem = handleGetSummaryItemByBatServiceCodeType(
            setDetails.summary
          )

          setSelectInvoice[setKey] = targetSummaryItem
            ? targetSummaryItem.batBillingGrantMunicipal
            : 0
        }
        break

      // 通所 END

      // 保訪 START
      case 'visitDetails':
        // 保訪の明細をフィルタリング
        setSelectInvoice[setKey] = setDetails.details.filter(
          (detailsItem: DetailsItemType) =>
            detailsItem.beServiceCode.slice(0, 2) === '64'
        )
        break

      case 'visitBatUnits':
        {
          const targetSummaryItem = handleGetSummaryItemByBatServiceCodeType(
            setDetails.summary,
            '64'
          )

          setSelectInvoice[setKey] = targetSummaryItem
            ? targetSummaryItem.batUnits
            : 0
        }
        break

      case 'visitBatTotalCost':
        {
          const targetSummaryItem = handleGetSummaryItemByBatServiceCodeType(
            setDetails.summary,
            '64'
          )

          setSelectInvoice[setKey] = targetSummaryItem
            ? targetSummaryItem.batTotalCost
            : 0
        }
        break

      case 'visitBatBillingAmount':
        {
          const targetSummaryItem = handleGetSummaryItemByBatServiceCodeType(
            setDetails.summary,
            '64'
          )

          setSelectInvoice[setKey] = targetSummaryItem
            ? targetSummaryItem.batBillingAmount
            : 0
        }
        break

      case 'visitBatBillingGrantMunicipal':
        {
          const targetSummaryItem = handleGetSummaryItemByBatServiceCodeType(
            setDetails.summary,
            '64'
          )

          setSelectInvoice[setKey] = targetSummaryItem
            ? targetSummaryItem.batBillingGrantMunicipal
            : 0
        }
        break

      // 保訪 END

      case 'batDecisionUbCost':
        {
          const batBillingGrantMunicipalTotal =
            setDetails.summaryTotal &&
            setDetails.summaryTotal.batBillingGrantMunicipalTotal
              ? setDetails.summaryTotal.batBillingGrantMunicipalTotal
              : 0

          const batDecisionUbCostTotal =
            setDetails.summaryTotal &&
            setDetails.summaryTotal.batDecisionUbCostTotal
              ? setDetails.summaryTotal.batDecisionUbCostTotal
              : 0

          setSelectInvoice[setKey] =
            Number(batDecisionUbCostTotal) -
            Number(batBillingGrantMunicipalTotal)
        }
        break
    }
  })

  setSelectInvoice.billingAmount = 0
}
